//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const AddFilter = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="AddFilter"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21705_4243)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.89734 8.95999C7.69702 8.6655 6 6.78093 6 4.5C6 3.57495 6.27912 2.7151 6.75773 2.00006H0.574792C0.12069 2.00006 -0.153329 2.46667 0.0920039 2.82195L4.59777 9.33373C4.65731 9.41972 4.68888 9.52038 4.68888 9.62236V13.4265C4.68888 13.6158 4.79648 13.7905 4.97153 13.8865L8.70175 15.9255C9.08482 16.1348 9.56689 15.8782 9.56689 15.4656V9.61502C9.56689 9.51704 9.59559 9.42172 9.65011 9.33839L9.89734 8.95999Z"
              fill="currentColor"
            />
            <circle cx={12} cy={4} r={4} fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 0.998718C12.3314 0.998719 12.6 1.26735 12.6 1.59872L12.6 3.39874H14.4C14.7314 3.39874 15 3.66737 15 3.99874C15 4.33011 14.7314 4.59874 14.4 4.59874L12.6 4.59874V6.39872C12.6 6.73009 12.3314 6.99872 12 6.99872C11.6686 6.99872 11.4 6.73009 11.4 6.39872L11.4 4.59874L9.60002 4.59874C9.26865 4.59874 9.00002 4.33011 9.00002 3.99874C9.00002 3.66737 9.26865 3.39874 9.60002 3.39874L11.4 3.39874L11.4 1.59872C11.4 1.26735 11.6686 0.998719 12 0.998718Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21705_4243">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
